import React from 'react';
import { Checkbox } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { Field } from '../Field/Field';
import { installableAppLabels } from 'client/blocks/Settings/channels/labels';
import * as keyset from 'i18n/InstallableAppForm';

import styles from './TvAppTargetPlatformSelect.module.scss';

const t = i18n(keyset);

interface Props {
    availableTargetPlatforms?: string[];
    selectedTargetPlatforms?: string[];
    disabled: boolean;
    updateSelectedTargetPlatforms: (platform: string, newValue: boolean) => void;
    error: string | undefined;
}

export const TvAppTargetPlatformSelect: React.FC<Props> = ({
    availableTargetPlatforms = [],
    selectedTargetPlatforms = [],
    disabled,
    updateSelectedTargetPlatforms,
    error,
}) => {
    const displayTargetPlatforms = [...new Set([...availableTargetPlatforms, ...selectedTargetPlatforms])].map(
        (value) => ({
            name: value,
            isSelected: selectedTargetPlatforms.indexOf(value) >= 0,
        }),
    );

    return (
        <>
            <Field
                fieldTitle={installableAppLabels.targetPlatforms}
                fieldDescription={t('target-platforms-description')}
                error={error}
                required
            >
                <div className={styles.targetPlatformsContainer}>
                    {displayTargetPlatforms.map((platformEntry) => {
                        return (
                            <Checkbox
                                key={platformEntry.name}
                                size="l"
                                content={platformEntry.name}
                                checked={platformEntry.isSelected}
                                disabled={disabled || !availableTargetPlatforms.includes(platformEntry.name)}
                                onChange={() =>
                                    updateSelectedTargetPlatforms(platformEntry.name, !platformEntry.isSelected)
                                }
                            />
                        );
                    })}
                </div>
            </Field>
        </>
    );
};
